<script setup>
import { inject } from "vue";
import { useI18n } from "vue-i18n";
import Step from "@Components/Stepper/Step.vue";
import FormTextarea from "@Components/Form/Textarea.vue";

const props = defineProps(["modelValue", "step"]);
defineEmits(["update:modelValue", "next", "back", "skip"]);

const { t: __ } = useI18n();
const requestsSettings = inject("requestsSettings");
</script>

<template>
    <Step :step="step" @next="$emit('next')" @back="$emit('back')" @skip="$emit('skip')" class="px-4 lg:px-8 sm:px-6">
        <template #header>
            <div class="mx-auto max-w-3xl">
                <h3 class="text-4xl font-semibold leading-tight text-center text-gray-900 dark:text-white">
                    {{ __("Générez du contenu IA à partir d'une liste d'URLs") }}
                </h3>
            </div>
        </template>

        <div class="mx-auto max-w-3xl flex flex-col items-center space-y-6">
            <div class="flex-grow w-full space-y-6">
                <FormTextarea
                    v-model="requestsSettings.url"
                    :label="__('Saisissez une url par ligne')"
                    :hint="__('Un titre sera généré sur chaque url')"
                    rows="10" />
            </div>
        </div>
    </Step>
</template>
